package org.maplibre.compose.interaction.internal

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.input.pointer.PointerInputChange
import kotlin.math.abs
import kotlin.math.sign

/** Tracks drag displacement after a contact crosses its movement threshold. */
internal class PointerDrag(
  first: PointerInputChange,
  private val slop: Float,
  private val verticalOnly: Boolean = false,
) {
  val origin = first.position

  private var previous = first
  var active = false
    private set

  /** A vertical-only drag whose motion crossed the threshold sideways first. */
  var rejected = false
    private set

  data class Motion(
    val started: Boolean,
    val delta: Offset,
    val thresholdOffset: Offset = Offset.Zero,
  )

  fun move(change: PointerInputChange): Motion? {
    val old = previous
    previous = change
    val delta = change.position - old.position
    if (delta == Offset.Zero) return null
    if (active) return Motion(false, delta)
    if (rejected) return null
    val displacement = change.position - origin
    val beyond =
      if (verticalOnly) {
        if (abs(displacement.x) >= slop && abs(displacement.x) > abs(displacement.y)) {
          rejected = true
          return null
        }
        if (abs(displacement.y) < slop || displacement.y == 0f) return null
        Offset(0f, displacement.y - sign(displacement.y) * slop)
      } else {
        val distance = displacement.getDistance()
        if (distance < slop || distance == 0f) return null
        displacement * ((distance - slop) / distance)
      }
    active = true
    return Motion(true, beyond, displacement - beyond)
  }
}
